import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Fetch, buildUrl } from 'helpers';
import { LOGIN_LIST, LOGIN_AS_ADMIN } from 'constants/apis';
import { ContentSwitch, Button } from 'Components';
import LoginAsAdminDesktop from './LoginAsAdminDesktop/LoginAsAdminDesktop';
import LoginAsAdminMobile from './LoginAsAdminMobile/LoginAsAdminMobile';

class LoginAsAdmin extends Component {
  constructor(props) {
    super(props);
    const keyPairs = {
      UserName: i18n.t('loginAsAdmin:UserName'),
      EmailId: i18n.t('loginAsAdmin:Email'),
      Phone: i18n.t('loginAsAdmin:Phone Number'),
      CellPhone: i18n.t('loginAsAdmin:CellPhone'),
      PasswordExpiryDate: i18n.t('loginAsAdmin:PasswordExpiryDate'),
      LoginAs: i18n.t('loginAsAdmin:LoginAs'),
    };

    this.state = {
      keyPairs,
      keys: Object.keys(keyPairs),
      data: [],
      abortController: new AbortController(),
      isLoading: false,
      search: '',
    };

    this.handleLoginAsAdmin = this.handleLoginAsAdmin.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);

    this.funcs = {
      handleLoginAsAdmin: this.handleLoginAsAdmin,
      handleSearchChange: this.handleSearchChange,
    };
  }

  componentDidMount() {
    this.props.setAppState({
      isNavCollapsed: true,
      headTitle: i18n.t('loginAsAdmin:LoginAs Admin'),
    });
  }

  handleLoginAsAdmin(UserCode) {
    const params = { UserCode };

    Fetch.Get(buildUrl(LOGIN_AS_ADMIN, params))
      .then((data) => {
        localStorage.setItem('IdentityToken', data.headers.get('IdentityToken'));
        localStorage.setItem('RefreshToken', data.headers.get('RefreshToken'));
        this.props.setAppState({
          ...this.props.freshState,
          isLoggedInAsAdmin: true,
        }, () => this.props.history.push('/'));
      });
  }

  handleSearchChange(e) {
    if (this.state.isLoading) {
      this.state.abortController.abort();
    }

    this.setState({
      search: e.target.value,
      data: [],
      abortController: new AbortController(),
    }, () => this.fetchUsers());
  }

  fetchUsers() {
    if (this.state.search.length < 3) return;

    this.state.abortController.abort();
    const abortController = new AbortController();
    const parameters = {
      SearchFields: 'UserName,EmailId',
      SearchValue: this.state.search,
    };

    this.setState({
      isLoading: true,
      data: [],
    });

    Fetch.Get(buildUrl(LOGIN_LIST, parameters), { signal: abortController.signal })
      .then(resp => resp.json())
      .then(data => this.setState({
        data: data.DataList,
        isLoading: false,
      }));
  }

  render() {
    const { state, props, funcs } = this;
    const data = this.state.data.map(item => ({
      ...item,
      LoginAs: (
        <Button onClick={() => this.handleLoginAsAdmin(item.UserCode)}>{i18n.t('loginAsAdmin:LoginAs')}</Button>
      ),
    }));

    const sharedProps = {
      data,
    };

    return (
      <ContentSwitch index={props.deviceIndex} {...state} {...props} {...funcs} {...sharedProps}>
        <LoginAsAdminMobile />
        <LoginAsAdminDesktop />
      </ContentSwitch>
    );
  }
}

LoginAsAdmin.propTypes = {
  setAppState: PropTypes.func,
  clientNumber: PropTypes.string,
  freshState: PropTypes.shape({}),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default LoginAsAdmin;



// WEBPACK FOOTER //
// ./src/containers/LoginAsAdmin/LoginAsAdmin.jsx